import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from "react";
import ReactDOM from 'react-dom';
import Select from 'react-select'



const IncomingClassValueEditor = forwardRef((props, ref) => {
    const [selectedVal, setSelectedVal] = useState(props.value);
    const [editing, setEditing] = useState(true);
    const refContainer = useRef(null);
    const refSelectInput = useRef(null);


    useEffect(() => {

        focus();
    }, []);


    useImperativeHandle(ref, () => {
        return {
            getValue() {
                return selectedVal != null ? selectedVal : props.value;
            },

            isPopup() {
                return true;
            }
        };
    });

    useEffect(() => {
        if (props.data.classificationCategory.value == undefined) {
            props.api.stopEditing();
        }
    }, [props.data.classificationCategory.value]);

    useEffect(() => {
        if (!editing) {
            props.api.stopEditing();
        }
    }, [editing]);

    const focus = () => {
        window.setTimeout(() => {
            let container = ReactDOM.findDOMNode(refContainer.current);
            if (container) {
                container.focus();
            }
        });
    };


    const onSelectChange = val => {
        setSelectedVal(val);
        setTimeout(function () {
            props.api.stopEditing();
            props.node.setDataValue("classificationValue", val);

        })

    }
    const onMouseOver = e => {
        refSelectInput.current.setState({ isOpen: true })
        let container = ReactDOM.findDOMNode(e.target).parentNode.getElementsByTagName("input")[0];
        if (container != undefined) {
            container.focus();
        }
    }


    return (<div style={{ width: props.column.actualWidth + 'px' }}>

        <span onMouseOver={onMouseOver} className="selectCell" ref={refContainer}>
            <Select
                autosize={true}
                menuIsOpen={true}
                defaultValue={selectedVal}
                onChange={onSelectChange}
                onChangeValue={onSelectChange}
                menuPortalTarget={document.body}
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                options={props.node.data.classificationValues} ref={refSelectInput}>
            </Select>
        </span>
    </div>
    );
});

export default IncomingClassValueEditor;
